import { Thread } from "@/components/assistant-ui/thread";
import { NewPrecedentSlideRuntime } from "./NewPrecedentSlideRuntime";

export default function TimePeriodBenchmarkStep() {
  return (
    <div className="h-full rounded-md">
        <NewPrecedentSlideRuntime>
          <Thread />
        </NewPrecedentSlideRuntime>
    </div>
  );
}
